export default __webpack_public_path__ + "assets/_Chapters/_Images/background/C-Teile-Sortiment/1.webp";